import { ICampaign, ECampaignPromotedType } from './index';

export const CHANNELS = [
	'facebook',
	'facebookPaid',
	'instagram',
	'instagramPaid',
	'twitter',
	'google',
	'googlePMAX',
	'googleDisplay',
	'sms',
	'email',
];

export const getDefaultChannels = (): string[] => {
	const baseChannels = [
		'facebook',
		'facebookPaid',
		'instagram',
		'instagramPaid',
		'twitter',
		'googlePMAX',
		'sms',
		'email',
	];

	return baseChannels;
};

export const PLACEMENTS = [
	'facebookFeedSocialMedia',
	'facebookStorySocialMedia',
	'instagramFeedSocialMedia',
	'instagramStorySocialMedia',
	'facebookFeedPaidAd',
	'facebookStoryPaidAd',
	'instagramFeedPaidAd',
	'instagramStoryPaidAd',
	'twitterSocialMedia',
	'googleSearch',
	'googleDISPLAY_MAIN',
	'googleDISPLAY_MAIN_PMAX',
	'googleDISPLAY_HORIZ',
	'googleDISPLAY_HORIZ_PMAX',
	'smsDirectMarketing',
	'emailDirectMarketing',
];

export const AVAILABLE_PLACEMENTS = [
	'googleDISPLAY_MAIN_PMAX',
	'googleDISPLAY_HORIZ_PMAX',
	'googleDISPLAY_MAIN',
	'googleDISPLAY_HORIZ',
	'googleSearch',
	'smsDirectMarketing',
	'emailDirectMarketing',
	'twitterSocialMedia',
	'facebookFeedPaidAd',
	'facebookStoryPaidAd',
	'instagramFeedPaidAd',
	'instagramStoryPaidAd',
];

export const defaultCampaign: ICampaign = {
	id: '',
	group: '',
	status: 'draft',
	title: '',
	description: '',
	destination: '',
	customerProfiles: [],
	promotedObject: {
		type: ECampaignPromotedType.landingPage,
		ids: [],
	},
	promotion: [],
	channels: [],
	budget: {
		total: 1000,
		currency: 'USD',
		breakdown: [], // Will be calculated when availableChannelGroups are available
	},
	brief: undefined,
	designDirections: [],
	creatives: [],
	schedule: undefined,
	lastUpdatedBy: {
		name: '',
		email: '',
		role: '',
		permissions: [],
		isEmailVerified: false,
		account: '',
		isInvited: false,
		id: '',
	},
	updatedAt: new Date(),
	placements: PLACEMENTS,
	audience: [],
	tone: [],
};
